import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppConfig } from './app-config';

import { ListResponse } from '../interfaces/response';
import { PliDisplayFormat } from '../models/pli-format';

@Injectable({
  providedIn: 'root'
})

export class PlisDisplayFormatService {

  private pliDisplayFormats: ListResponse<PliDisplayFormat>;

  constructor(
    private _http: HttpClient,
    private _config: AppConfig
  ) { }

  public init() {
    this.pliDisplayFormats = null;
  }
  public getPliDisplayFormat(compsearchId: number, jurisdictionId: number): Observable<ListResponse<PliDisplayFormat>> {
    if (this.pliDisplayFormats) {
      return of(this.pliDisplayFormats);
    } else {
      const apiUrl = `${this.getResourceUrl()}/v1/compsearch/${compsearchId}/jurisdiction/${jurisdictionId}/get-jurisdiction-pli-formats`;
      return this._http.get<ListResponse<PliDisplayFormat>>(apiUrl).pipe(map((response) => {
        this.pliDisplayFormats = response;
        return this.pliDisplayFormats;
      }));
    }
  }

  public savePliDisplayFormat(pliTypeId: number, pliAverageTypeId: number, compsearchId: number, jurisdictionId: number, pliDisplayFormat: { displayFormat: number }): Observable<ListResponse<PliDisplayFormat>> {
    const apiUrl = `${this.getResourceUrl()}/v1/compsearch/${compsearchId}/jurisdiction/${jurisdictionId}/pliTypeId/${pliTypeId}/pli-avg/${pliAverageTypeId}/save-pli-format`;
    return this._http.put<ListResponse<PliDisplayFormat>>(apiUrl, pliDisplayFormat);
  }

  protected getResourceUrl(): string {
    return `${this._config.getCompSearchApiUrl()}`;
  }
}
